import { createClient } from '@supabase/supabase-js';
import type { Database } from '@powerful/types';

import { readPublicSupabaseEnv, type SupabaseEnvSource } from './env';

/**
 * `Database` vem do schema real, gerado por `node scripts/typegen.mjs` (T0.8). Antes disto o
 * client era `SupabaseClient<any>` e uma coluna inexistente só falhava em runtime.
 */
export function createBrowserSupabaseClient(source: SupabaseEnvSource) {
  const env = readPublicSupabaseEnv(source);

  return createClient<Database>(env.url, env.publishableKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      // 🔴 T1.19 (/code-review): a URL de retorno do Auth é consumida SÓ pela página
      // `/auth/callback`, que depois ativa a conta (signup) ou abre a troca de senha (recovery).
      // Com a deteção automática, o SDK trocava o fragmento por sessão na inicialização e limpava-o
      // antes de a página montar: o link válido aparecia como expirado e a ativação nunca corria.
      detectSessionInUrl: false,
    },
  });
}
